// extracted by mini-css-extract-plugin
module.exports = {"phoneTab":"phone_phoneTab__r3G_c","form":"phone_form__XaCBF","leftContent":"phone_leftContent__2yGpH","icon":"phone_icon__B84Be","select":"phone_select___IkFo"};